import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { TextField, Button, Select, MenuItem, FormControl, InputLabel, Box, Grid, Snackbar, Alert, AlertColor } from "@mui/material";
import axios from "axios";

const API_URL = `${process.env.REACT_APP_BASE_API_URL}/api/fingerprints`;

const EditFingerprint = (props) => {


  const {content,category,fontColor,fontSize,hexValue,id,layout,number,position,size} = props.row

  const [formValues, setFormValues] = useState({
    category: category,
    fontSize: fontSize,
    layout: layout,
    fontColor: fontColor,
    size: size,
    position: position,
    number: number,
  });

  const [snackbar, setSnackbar] = useState<{
      open: boolean;
      message: string;
      severity: AlertColor;
    }>({
      open: false,
      message: "",
      severity: "success", 
    });


  const [categories, setCategories] = useState([]);
  const [layouts, setLayouts] = useState([]);
  const [fontSizes, setFontSizes] = useState([]);
  const [fontColors, setFontColors] = useState([]);

  // Fetch the fingerprint and dropdown options
  useEffect(() => {
  
    fetchDropdownOptions();
  }, [props.row.id]); 


  const fetchDropdownOptions = () => {
    setCategories([
      { id: "movies", name: "Movies" },
      { id: "sports", name: "Sports" },
      { id: "news", name: "News" },
    ]);

    setLayouts([
      { id: "full_screen", name: "Full Screen" },
      { id: "watermark", name: "Watermark" },
    ]);

    setFontSizes([
      { id: "small", label: "Small" },
      { id: "medium", label: "Medium" },
      { id: "large", label: "Large" },
    ]);

    setFontColors([
      { id: "red", label: "Red" },
      { id: "green", label: "Green" },
      { id: "blue", label: "Blue" },
    ]);
  };

  const handleChange = (event) => {
    setFormValues({ ...formValues, [event.target.name]: event.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await axios.put(`${API_URL}/${id}`, formValues); 
      setTimeout(() => {
        
        props.handleClose();
      }, 2000); 
      setSnackbar({ open: true, message: "FingerPrint updated successfully!", severity: "success" });
      props.fetchFingerprints(); 
    } catch (error) {
      console.error("Error updating fingerprint:", error);
      setSnackbar({ open: true, message: "Failed to FingerPrint update !", severity: "error" });
    }
  };

 
  useEffect(() => {
    if (formValues.category) {
      console.log('Updated formValues:', formValues); 
    }
  }, [formValues]);

  return (
    <Box sx={{ padding: 3, maxWidth: 600, margin: "auto" }}>
     
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormControl fullWidth sx={{opacity:'1'}}>
              <InputLabel>Category</InputLabel>
              <Select name="category" sx={{color:'white',display:"visible"}} value={props.row.category} onChange={handleChange}>
                {categories.map((category) => (
                  <MenuItem key={category.id} value={category.id}>
                    {category.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Font Size</InputLabel>
              <Select name="fontSize" value={formValues.fontSize} onChange={handleChange}>
                {fontSizes.map((size) => (
                  <MenuItem key={size.id} value={size.id}>
                    {size.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Layout</InputLabel>
              <Select name="layout" value={formValues.layout} onChange={handleChange}>
                {layouts.map((layout) => (
                  <MenuItem key={layout.id} value={layout.id}>
                    {layout.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Font Color</InputLabel>
              <Select name="fontColor" value={fontColor} onChange={handleChange}>
                {fontColors.map((color) => (
                  <MenuItem key={color.id} value={color.id}>
                    {color.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Size"
              type="number"
              name="size"
              value={formValues.size}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Position</InputLabel>
              <Select name="position" value={formValues.position} onChange={handleChange}>
                <MenuItem value="top">Top</MenuItem>
                <MenuItem value="bottom">Bottom</MenuItem>
                <MenuItem value="left">Left</MenuItem>
                <MenuItem value="right">Right</MenuItem>
                <MenuItem value="center">Center</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Number"
              type="number"
              name="number"
              value={formValues.number}
              onChange={handleChange}
            />
          </Grid>
        </Grid>

        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 3 }}>
          <Button type="submit" variant="contained" color="primary" sx={{ marginRight: 2 }}>
            Update
          </Button>
         <Button variant="outlined" color="secondary" onClick={props.handleClose}>
                     Cancel
                   </Button>
        </Box>
      </form>

         <Snackbar
                       open={snackbar.open}
                       autoHideDuration={6000}
                       onClose={() => setSnackbar({ ...snackbar, open: false })}
                       anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                       sx={{zIndex:'100'}}
                      >
                     <Alert
                      onClose={() => setSnackbar({ ...snackbar, open: false })}
                      severity={snackbar.severity}
                       variant="filled"
                         >
                     {snackbar.message}
                       </Alert>
                    </Snackbar>
    </Box>
  );
};

export default EditFingerprint;